export default "__VITE_PUBLIC_ASSET__4ee8e253__"